import Head from 'next/head';
import React from 'react';

import { BreadcrumbsProps } from '@/components/breadcrumbs';
import AppLayoutBase from '@/components/layouts/app-layout/base';

export interface AppLayoutProps {
  title?: string;
  children?: React.ReactNode[] | React.ReactNode;
  breadcrumbItems?: BreadcrumbsProps['items'];
  breadcrumbActions?: React.ReactNode;
}

const AppLayout = ({
  title = 'This is the default title',
  children,
  breadcrumbItems,
  breadcrumbActions,
}: AppLayoutProps) => {
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <link rel="icon" href="/favicon.ico" sizes="any" />
        <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
        <link rel="manifest" href="/site.webmanifest" />
        <meta name="robots" content="noindex" />
      </Head>

      <AppLayoutBase breadcrumbItems={breadcrumbItems} breadcrumbActions={breadcrumbActions}>
        {children}
      </AppLayoutBase>
    </>
  );
};

export { AppLayout };
